<template>
  <div>
    <div class="input-field col s12 ">
      <i class="icons-in-form large material-icons prefix "
      >fingerprint</i
      >
      <input
          @input="$emit('update:password', $event.target.value)"
          v-model="password"
          id="password"
          type="password" />
      <label for="password">Contraseña</label>
        <div class="label-check-container" v-if="password.length">
          <div class="label-check"  v-for="requirement  in passwordRequirements" >
            <div  class="label-check" v-if="requirement.isVisible">
              <div class="label-check-green" v-if="requirement.correct">
                <span class="material-symbols-outlined size-icon-label" >
                  check
                </span>
                  <span class="size-label">
                  {{requirement.label}}
                </span>
              </div>
              <div class="label-check-red" v-else>
                <span class="material-symbols-outlined size-icon-label" >
                  close
                </span>
                <span class="size-label">
                  {{requirement.label}}
                </span>
              </div>
            </div>

          </div>
        </div>


    </div>
    <div class="input-field col s12 ">
      <i class="icons-in-form large material-icons prefix ">check_circle</i>
      <input
          @input="$emit('update:confirmPassword', $event.target.value)"
          v-model="confirmPassword"
          id="confirmPassword"
          type="password"/>
      <label for="confirmPassword">Confirmacion de contraseña</label>
      <div class=" label-check-container " v-if="confirmPassword.length">
        <div class="label-check-green" v-if="equalPasswords">
          <span class="material-symbols-outlined size-icon-label" >
            check
          </span>
          <span class="size-label">
            Las contraseñas coinsiden
          </span>
        </div>
        <div class="label-check-red" v-else>
          <span class="material-symbols-outlined size-icon-label" >
            close
          </span>
          <span class="size-label">
           Las Contraseñas no coinciden
          </span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {passwordRequirements, passwordRequirementsAdmin} from '@/constantes'


export default {
  name: "inputPassword",
  props: ['nivel'],
  data(){
    return{
      confirmPassword: '',
      password: '',
      passwordRequirements:[],
      seeLabels: false,
      equalPasswords: false,
      valido: false
    }
  },
  watch:{
    password(newPassword){
      this.passwordRequirements = this.passwordRequirements.map(requirement=>{
        let isVisible = true
        let correct = requirement.regex.test(newPassword)
        if(requirement.name == `withoutSpaces`) {
          isVisible = requirement.regex.test(newPassword)
          correct = !requirement.regex.test(newPassword)
          console.log(`entra`, isVisible)
        }
        return {
          ...requirement,
          correct,
          isVisible
        }
      })
      this.equalPasswords = newPassword == this.confirmPassword
    },
    confirmPassword(newPassword){
      this.equalPasswords = newPassword == this.password
    },
    nivel(newNivel){
      if(this.nivel == 1){
        console.log(passwordRequirementsAdmin)
        this.passwordRequirements = passwordRequirementsAdmin.map(requirement=>{
          return {
            ...requirement,
            correct: false
          }
        })
      }
      else{
        console.log(passwordRequirements)
        this.passwordRequirements = passwordRequirements.map(requirement=>{
          return {
            ...requirement,
            correct: false
          }
        })
      }
      if(this.password.length)
        this.passwordRequirements = this.passwordRequirements.map(requirement=>{
          let isVisible = true
          let correct = requirement.regex.test(this.password)
          if(requirement.name == `withoutSpaces`) {
            isVisible = requirement.regex.test(this.password)
            correct = !requirement.regex.test(this.password)
            console.log(`entra`, isVisible)
          }
          return {
            ...requirement,
            correct,
            isVisible
          }
        })

    }
  },
  methods:{
    validPassword(){

      const requirements = this.passwordRequirements.find(requirement => !requirement.correct)
      console.log(this.passwordRequirements, requirements, `lso requerimientos`)

      return  !requirements

    },
    validconfirmPassword(){

      return this.equalPasswords

    },
  },
  mounted() {
    this.$nextTick(()=>{
      if(this.nivel == 1){
        console.log(passwordRequirementsAdmin)
        this.passwordRequirements = passwordRequirementsAdmin.map(requirement=>{
          return {
            ...requirement,
            correct: false
          }
        })
      }

      else{
        console.log(passwordRequirements)
        this.passwordRequirements = passwordRequirements.map(requirement=>{
          return {
            ...requirement,
            correct: false
          }
        })
      }

    })
  }
}
</script>

<style scoped>
.label-check-container{
  margin-left: 2.5rem;
  /*margin-left: 2.5rem;*/
  /*font-size: 16px;*/
}
.size-icon-label{
  font-size: 22px !important;
  position: absolute; top: -2px !important;
  margin-left: 5px;
}

.size-label{
  font-size: 15px !important;
  margin-left: 25px;
  display: inline;


}
.label-check{
  display: inline;
  font-size: 16px;
}
.label-check-green{
  position: relative;
  color: #00b134;
  display: inline;
}

.label-check-red{
  position: relative;
  color: #b40000;
  display: inline;
}
</style>